import { useTenantAdminCompanyRoleEnabled } from '../../feature-flags/useTenantAdminCompanyRoleEnabled';
import {
  canEditOrCancelServiceRequest,
  type ServiceRequestOwners,
  type ServiceRequestUser,
} from './canEditOrCancelServiceRequest';
import { isCompanyServiceRequestHolder } from './isCompanyServiceRequestHolder';

export interface CompanyServiceRequest {
  company?: { id?: string | null } | null;
}

interface UseCompanyServiceRequestAccess {
  canViewSubmitter: (serviceRequest: CompanyServiceRequest) => boolean;
  canEditOrCancel: (serviceRequest: ServiceRequestOwners) => boolean;
}

/**
 * While the company role feature is off, everyone may edit or cancel and
 * `canViewSubmitterWhenDisabled` decides who sees the submitter.
 */
export const useCompanyServiceRequestAccess = (
  user: ServiceRequestUser | null | undefined,
  canViewSubmitterWhenDisabled = false
): UseCompanyServiceRequestAccess => {
  const isEnabled = useTenantAdminCompanyRoleEnabled();

  return {
    canViewSubmitter: serviceRequest =>
      isEnabled
        ? isCompanyServiceRequestHolder(user, serviceRequest.company?.id)
        : canViewSubmitterWhenDisabled,
    canEditOrCancel: serviceRequest =>
      !isEnabled || canEditOrCancelServiceRequest(user, serviceRequest),
  };
};
